<template lang="">
    <el-container>
         <el-aside width="auto">
            <CommonAside />
         </el-aside>
         <el-container>
            <el-header>
                  <CommonHeader />
            </el-header>
            <CommonTag />
            <el-main>
             <router-view></router-view>
            </el-main>
        </el-container>
    </el-container>
</template>
<script>
import CommonAside from '../components/CommonAside.vue'
import CommonHeader from '../components/CommonHeader.vue'
import CommonTag from '../components/CommonTag.vue'
export default {
    data() {
        return {

        }
    },
    components: {
        CommonAside,
        CommonHeader,
        CommonTag
    }
}
</script>
<style lang="less" scoped>
.el-header {
    padding: 0;
}

.el-main {
    padding: 0 20px 20px;
}
</style>